export const IconProjectLocation = ({
	color,
}: {
	color: string;
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="19"
		viewBox="0 0 18 19"
		fill="none"
		aria-hidden="true"
	>
		<path
			d="M9.00016 10.5725C10.2925 10.5725 11.3402 9.5248 11.3402 8.23246C11.3402 6.94011 10.2925 5.89246 9.00016 5.89246C7.70781 5.89246 6.66016 6.94011 6.66016 8.23246C6.66016 9.5248 7.70781 10.5725 9.00016 10.5725Z"
			stroke={color}
			strokeWidth={1.5}
		/>
		<path
			d="M2.71478 6.8675C4.19228 0.372502 13.8148 0.380002 15.2848 6.875C16.1473 10.685 13.7773 13.91 11.6998 15.905C10.1923 17.36 7.80728 17.36 6.29228 15.905C4.22228 13.91 1.85228 10.6775 2.71478 6.8675Z"
			stroke={color}
			strokeWidth={1.5}
		/>
	</svg>
);
